import React from "react";
import VStack from "../../../ui_atoms/VStack";
import { MockedProvider } from "@apollo/client/testing";
import type { Meta, StoryObj } from "@storybook/react";
import CreateMissionsManager from "../../../contexts/CreateMissionManager";
import CreateMissionTimeSheet from "../../../screens/create-mission/CreateMissionTimeSheet";

function StoryComponent() {
    return (
        <MockedProvider mocks={[]}>
            <VStack gap={1} style={{ alignItems: "stretch", alignSelf: "stretch", flex: 1 }}>
                <CreateMissionsManager
                    onValidate={(mission) => {
                        alert(`Screen Validated payrollSource: ${mission.payrollSource} `);
                    }}
                >
                    <CreateMissionTimeSheet />
                </CreateMissionsManager>
            </VStack>
        </MockedProvider>
    );
}

const meta = {
    title: "CreateMission/Timesheet",
    component: StoryComponent,
    argTypes: {},
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
